import React from 'react';
import './BlazinAttachment.scss';
import { BarChartComponent } from './BarChartComponent';
import { LeaderBoardComponent } from './LeaderBoardComponent';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import { DateTime } from 'luxon';
const BlazinAttachment = props => {
  var _metadata$results;
  const {
    data,
    metadata,
    text,
    bohStyle,
    duration,
    playing
  } = props;
  const logo = metadata.logo;
  const {
    containerStyle,
    accent_color,
    text_accent_color
  } = bohStyle;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const {
    employees
  } = data;
  const loyaltyEmployees = employees ? employees.slice(0, results) : [];
  const generateDescription = date => {
    if (!date) return 'N/A';
    const lastUpdatedDate = DateTime.fromISO(date);
    const dateFormatted = lastUpdatedDate.toFormat('MM/dd');
    const timeFormatted = lastUpdatedDate.toFormat('hh:mm a');
    return 'As of ' + dateFormatted + ' at ' + timeFormatted;
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "header-blazin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bar"
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: generateDescription(data.last_updated),
    isLeaderboard: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, logo && /*#__PURE__*/React.createElement("img", {
    className: "logo-icon",
    src: logo,
    alt: "logo"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "blazin-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(LeaderBoardComponent, {
    employees: loyaltyEmployees,
    duration: duration,
    playing: playing,
    accent_color: accent_color
  }), /*#__PURE__*/React.createElement(BarChartComponent, {
    thisWeek: data.this_week,
    lastWeek: data.last_week
  }), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  })));
};
export default BlazinAttachment;